import { lazy } from 'react';

const AprrovedMarketerCertificationConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/marketer/consult/transfer',
			component: lazy(() => import('./AprrovedCertificationContainer'))
		}
	]
};

export default AprrovedMarketerCertificationConfig;

